import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import IntervalService from './../../services/intervals';
import Grid from '@mui/material/Grid';
import settingsStore from '../../stores/settings';
import ToggleButton from '@mui/material/ToggleButton';
import SvgIcon from '@mui/material/SvgIcon';
import MenuItem from '@mui/material/MenuItem';
import Confirm from './../dialogs/Confirm';
import Menu from '@mui/material/Menu';
import SavePlayList from './../dialogs/SavePlayList';
import { ReactComponent as SmartQIcon } from './../../assets/smartq.svg';
import SmartQConfirmation from '../dialogs/SmartQConfirmation';
import DisableSmartQConfirmation from '../dialogs/DisableSmartQConfirmation';
import DeleteDialog from './../dialogs/DeleteDialog';
import Tooltip from '@mui/material/Tooltip';
import sessionStore from '../../stores/session';
import playerStore from './../../stores/player';
import performanceStore from '../../stores/performance';
import messageStore from './../../stores/message';

function PlayQueueBottomBar(props) {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const setSettings = settingsStore((state) => state.setSettings);
  const settings = settingsStore((state) => state.settings);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const emptyPlayer = playerStore((state) => state.empty);
  const ackSmartQ = sessionStore((state) => state.ackSmartQ);
  const clearSmartQ = performanceStore((state) => state.clearSmartQ);
  const clearPlayQueue = performanceStore((state) => state.clearPlayQueue);
  const playQueue = performanceStore((state) => state.playQueue);
  const playQueueDuration = performanceStore((state) => state.playQueueDuration);
  const sortBySmartQ = performanceStore((state) => state.sortBySmartQ);
  const playLists = performanceStore((state) => state.playLists);
  const getPlayLists = performanceStore((state) => state.getPlayLists);
  const savePlayQueue = performanceStore((state) => state.savePlayQueue);
  const savePlayList = performanceStore((state) => state.savePlayList);
  const currentPlayList = performanceStore((state) => state.currentPlayList);
  const setError = messageStore((state) => state.setError);

  const [chosenPlayList, setChosenPlayList] = useState(null);

  const [isSavePlayListOpen, setIsSavePlayListOpen] = useState(false);
  const [isSavePlayQueueOpen, setIsSavePlayQueueOpen] = useState(false);
  const [isDisableSmartQOpen, setIsDisableSmartQOpen] = useState(false);


  const handleOpenSavePlayList = () => {
    setIsSavePlayListOpen(true);
  };

  const handleCloseSavePlayList = () => {
    setIsSavePlayListOpen(false);
  };

  const handleOpenSavePlayQueue = () => {
    setIsSavePlayQueueOpen(true);
  };

  const handleCloseSavePlayQueue = () => {
    setIsSavePlayQueueOpen(false);
  };

  useEffect(() => {
    if (!playLists) {
      getPlayLists(sessionToken);
    }
  }, []);

  useEffect(() => {
    console.log("func settings");

  }, [settings]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [isBottomBarSaveMenuOpen, setBottomBarSaveMenuOpen] = useState(false);

  const handleBottomBarSaveMenuClose = () => {
    setBottomBarSaveMenuOpen(false);
  };

  const [isClearDialogOpen, setIsClearDialogOpen] = useState(false);

  const [isSmartQConfirmationOpen, setIsSmartQConfirmationOpen] = useState(false);

  const handleOpenSmartQConfirmation = () => {
    setIsSmartQConfirmationOpen(true);
  };

  const handleCloseSmartQConfirmation = () => {
    setIsSmartQConfirmationOpen(false);
  };

  const handleOpenDisableSmartQ = () => {
    setIsDisableSmartQOpen(true);
  };

  const handleCloseDisableSmartQ = () => {
    setIsDisableSmartQOpen(false);
  };

  const handleOpenClearDialog = () => {
    setIsClearDialogOpen(true);
  };

  const handleCloseClearDialog = () => {
    setIsClearDialogOpen(false);
  };

  const handleDisableSmartQ = () => {
    toggleSmartq();
    handleCloseDisableSmartQ();
  };

  const toggleSmartq = () => {
    if (settings) {
      let newSettings = { ...settings };
      newSettings.smartq_enabled = !(settings.smartq_enabled == 1);
      if (newSettings.smartq_enabled) {
        ackSmartQ();
        sortBySmartQ(sessionToken);
      } else {
        clearSmartQ(sessionToken);
      }
      setSettings(sessionToken, newSettings);
    }
    setIsSmartQConfirmationOpen(false);
  };

  const toMinutes = (secs) => {
    var sec_num = parseInt(secs, 10);
    var minutes = Math.floor(sec_num / 60);
    return minutes;
  };

  const calcLength = () => {
    if (playQueue && settings) {
      if (playQueue.items.length > 0) {
        let autoPlaySecs = settings.autoplay_enabled ? settings.autoplay_secs : 0;
        let itemsCount = playQueue.items.length;
        let secs = playQueueDuration + (autoPlaySecs * (itemsCount - 1));
        return toMinutes(secs);
      }
    }
    return 0;
  };

  const onClearing = () => {
    IntervalService.clearAllIntervals();
    setIsStopped(true);
    emptyPlayer();
    clearPlayQueue(sessionToken);
    handleCloseClearDialog();
  };

  const openBottomBarSaveMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setBottomBarSaveMenuOpen(true);
  };

  const handlePlayQueueSave = (playListName) => {
    if (playListName.length > 0) {
      savePlayQueue(sessionToken, playListName);
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
    setIsSavePlayQueueOpen(false);
  };

  const renderSmartQButton = () => {
    if (settings) {
      if (settings.smartq_enabled) {
        return <Tooltip title={TR.cm_disable_smartq_now}>
          <ToggleButton className="muvika-smartq-button" selected value="check" onChange={handleOpenDisableSmartQ}>
            <SvgIcon viewBox="0 0 48 24" className="muvika-smartq-icon" component={SmartQIcon} />
          </ToggleButton>
        </Tooltip>;
      }
    }
    return <Tooltip title={TR.cm_enable_smartq_now}>
      <ToggleButton selected={false} className="muvika-smartq-button" value="check" onChange={handleOpenSmartQConfirmation}>
        <SvgIcon viewBox="0 0 48 24" className="muvika-smartq-icon" component={SmartQIcon} />
      </ToggleButton>
    </Tooltip>;
  };

  const handleConfirmation = () => {
    savePlayList(sessionToken, chosenPlayList.id, chosenPlayList.name);
    setIsSavePlayListOpen(false);
  };

  const renderMenuPlayLists = () => {
    if (playLists) {
      return playLists.sort(function (a, b) {
        let textA = a.name;
        let textB = b.name;
        return textA.localeCompare(textB);
      }).map((playList, index) =>
        <MenuItem
          key={playList.id}
          selected={currentPlayList ? currentPlayList.id == playList.id : false}
          onClick={() => {
            handleBottomBarSaveMenuClose();
            setChosenPlayList(playList);
            handleOpenSavePlayList();
          }}
        >
          {playList.name}
        </MenuItem>
      );
    }
  };

  const renderSaveButton = () => {
    if (settings) {
      if (!settings.usage_mode || !settings.usage_mode || settings.usage_mode === "restaurant") {
        return <Button
          color="success"
          aria-controls={isBottomBarSaveMenuOpen ? "menu-bottombar-save" : undefined}
          aria-haspopup="true"
          aria-expanded={isBottomBarSaveMenuOpen ? 'true' : undefined}
          onClick={openBottomBarSaveMenu}
        >{TR.cm_save}
          ...
        </Button>;
      }
    }
  };

  return (
    <Grid id="muvika-playqueue-bottom-bar" container spacing={0}>
      <SmartQConfirmation
        open={isSmartQConfirmationOpen}
        onClose={handleCloseSmartQConfirmation}
        onConfirmation={toggleSmartq}
      />
      <SavePlayList
        open={isSavePlayQueueOpen}
        onClose={handleCloseSavePlayQueue}
        onPlayListSave={handlePlayQueueSave}
      />
      <Confirm
        open={isSavePlayListOpen}
        onClose={handleCloseSavePlayList}
        onConfirmation={handleConfirmation}
      />
      <DisableSmartQConfirmation
        open={isDisableSmartQOpen}
        onClose={handleCloseDisableSmartQ}
        onConfirmation={handleDisableSmartQ}
      />
      <DeleteDialog
        open={isClearDialogOpen}
        onClose={handleCloseClearDialog}
        onDeletion={onClearing}
        title={TR.cm_are_you_sure}
        cancel={TR.cm_cancel}
        delete={TR.cm_clear}
      />
      <Grid item xs={8} justifyContent="left">
        <Stack className="muvika-playqueue-bottom-bar-stack" direction="row" spacing={2}>
          {renderSaveButton()}
          <Button color="secondary" onClick={handleOpenClearDialog}>{TR.cm_clear}</Button>
          {renderSmartQButton()}
        </Stack>
      </Grid>
      <Grid item xs={4}>
        <Stack className="muvika-playqueue-bottom-bar-stack" direction="row" spacing={2} justifyContent="right">
          <span className="muvika-playqueue-duration">
            {TR.cm_duration}: {calcLength()} min
          </span>
        </Stack>
      </Grid>
      <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus  
        id={"menu-bottombar-save"}
        style={{ zIndex: 99999 }}
        open={isBottomBarSaveMenuOpen}
        anchorEl={anchorEl}
        onClose={handleBottomBarSaveMenuClose}
        MenuListProps={{
          'aria-labelledby': "menu-bottombar-save",
        }}
      >
        <MenuItem onClick={() => {
          handleBottomBarSaveMenuClose();
          handleOpenSavePlayQueue();
        }}>
          &raquo; {TR.cm_create_new_playlist}
        </MenuItem>
        {renderMenuPlayLists()}
      </Menu>
    </Grid>
  );
}

export default PlayQueueBottomBar;